import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import { lighten } from 'polished';
import { Icon, IconifyIcon } from '@iconify/react';

import PresetIcons from '../common/PresetIcons';
import { NekoTooltip } from './Tooltip';

const StyledIconContainer = Styled.div`
  display: flex;
  align-items: center;
`;

const hoverColor = (color, hoverColor) => {
  if (hoverColor) {
    return `
    &:hover {
      path {
        fill: ${hoverColor};
      }
    }
    `;
  }
  if (color) {
    return `
    &:hover {
      path {
        fill: ${lighten(0.1, color)};
      }
    }
    `;
  }
};

const StyledIcon = Styled(Icon)`

  path {
    fill: ${props => props.color};
  }

  ${props => hoverColor(props.color, props.hoverColor)}

  &.nui-clickable {
    cursor: pointer;
  }

  &.spin {
    animation-name: spin;
    animation-duration: 700ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes spin {
      0% {
        transform: rotate(360deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.35;
    cursor: default;
  }
`;

const StyledNekoIcon = props => {

  let { icon, spinning = false, className = '', title, tooltip, containerStyle, color, hoverColor, disabled = false, ...rest } = props;

  if (!rest.width && !rest.height) {
    rest.width = rest.height = 30;
  }

  const getIcon = () => {
    if (typeof icon === 'string') {
      return PresetIcons[icon] || null;
    }
    return icon;
  };

  const iconClassName = `nui-icon ${className}${rest.onClick ? ' nui-clickable' : ''}${spinning ? ' spin' : ''}${disabled ? ' disabled' : ''}`;

  if (tooltip) {
    return (
      <NekoTooltip text={tooltip.text} position={tooltip.position || 'top'}>
        <StyledIconContainer style={containerStyle}>
          <StyledIcon icon={getIcon()} className={iconClassName} color={color} hoverColor={hoverColor} {...rest}/>
        </StyledIconContainer>
      </NekoTooltip>
    );
  }

  return (
    <StyledIconContainer style={containerStyle} title={title}>
      <StyledIcon icon={getIcon()} className={iconClassName} color={color} hoverColor={hoverColor} {...rest} />
      {!tooltip ? null : <NekoTooltip>{tooltip}</NekoTooltip>}
    </StyledIconContainer>
  );
};

const NekoIcon = (props) => {
  return (<StyledNekoIcon {...props} />);
};

NekoIcon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.instanceOf(IconifyIcon), PropTypes.oneOf(['lock' ,'lock-open' ,'file-undo' ,'chevron-double-left' ,'chevron-double-right' ,'chevron-left' ,'chevron-right' ,'chevron-down' ,'chevron-up' ,'pause' ,'play' ,'replay' ,'check' ,'stop' ,'delete' ,'undo' ,'alert' ,'database' ,'pencil' ,'tools' ,'cog' ,'close' ,'cat' ,'upload'])]),
  color: PropTypes.string,
  spinning: PropTypes.bool,
  className: PropTypes.string,
  tooltip: PropTypes.string
};

NekoIcon.defaultProps = {
  icon: undefined,
  color: undefined,
  spinning: false,
  className: '',
  tooltip: undefined
};

export { NekoIcon };
